import { i18n } from '@/contexts/i18n/i18n';
import { genActionMap } from '@/scripts/router';

const { t } = i18n;

export enum ActionKeys {
  VIEW = 'view',
  CREATE = 'create',
  UPDATE = 'update',
  DELETE = 'delete',
}

const actionMap = genActionMap({
  [ActionKeys.VIEW]: {
    get title() {
      return t('action.view');
    },
  },
  [ActionKeys.CREATE]: {
    get title() {
      return t('action.create');
    },
  },
  [ActionKeys.UPDATE]: {
    get title() {
      return t('action.update');
    },
  },
  [ActionKeys.DELETE]: {
    get title() {
      return t('action.delete');
    },
  },
});

export default actionMap;
